import { objComparatorNumber } from "../utils.js";
import axios from 'axios';
import { endpoint, remoteCreate } from "./utils.js";

export function PMSRootURL() {
  return endpoint("internal/current/pms/");
}

export async function fetchPMSes() {
  const res = await axios.get(PMSRootURL(), {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id')).map(el => {
    return { ...el, visual_name: `${el['id']} - ${el['name']}` };
  });
}

export async function fetchPMSPendingReqs(pmsId) {
  const res = await axios.get(`${PMSRootURL()}${pmsId}/pendingrequests/`, {
    withCredentials: true
  });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id'));
}

export async function createPMS(useAlerts, payload) {
  await remoteCreate(useAlerts, PMSRootURL(), payload, 'PMS', 'PMS');
}

export async function createPMSPendingReq(useAlerts, payload, pmsId) {
  await remoteCreate(useAlerts, `${PMSRootURL()}${pmsId}/pendingrequests/`, payload, 'PMS Pending Request', 'PMS PR');
}
